module.exports = __webpack_public_path__ + "img/card1.a7e2926a.png";